import { Component, ContentChild, HostListener, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';

@Component({
    selector: 'tvcore-accordion',
    templateUrl: './accordion.component.html',
    styleUrls: ['./accordion.component.scss'],
    standalone: false
})
export class AccordionComponent implements OnInit {
	@Input()
	title: string;
	@Input()
	open?: boolean = false;
	@Input()
	leftPadding: boolean = false;

	@ViewChild('accordionContent')
	accordionContent: any;

	@ContentChild('right')
	rightTemplate: TemplateRef<any>;
	@ContentChild('arrow')
	arrowTemplate: TemplateRef<any>;

	height: string;

	ngOnInit() {
		this.calculateHeight();
	}

	@HostListener('window:resize')
	onResize() {
		this.calculateHeight();
	}

	private calculateHeight() {
		setTimeout(() => {
			this.height = `${this.accordionContent?.nativeElement.scrollHeight}px`;
		}, 200);
	}
}
